module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAOVBMVEUAAAB/f39/f393d3d3d3d6enp4eHh4eHh4eHh3d3d5eXl5eXl4eHh4eHh3d3d0dHR5eXl4eHh4eHjvR0mBAAAAEnRSTlMAEAj3IDDv38+3UI/Hn0AYKL8QgK45AAAAZ0lEQVR42u3RNQJCMRQF0XiCw9v/YnEuOqnwP/Xpxj2vMJpMfdeYWfM9U8Z1r8hkl/YKjZMCIwVGCowUGCkyUmSkyEiRkSIjRUZKhtXMbA7Pl9FW7peeD89lQC32hlWUAcVmr9qNWQPt6QnuAcOaFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/空心菱形.png
// module id = 5kBk
// module chunks = 2